export function SiteFooter() {
  return (
    <footer className="mono-footer">
      <div className="mono-footer__inner">
        <div className="mono-footer__grid">
          <div className="mono-footer__brand">
            <a className="mono-footer__word" href="/">mono</a>
            <p>Send USDC to friends and family on iMessage.</p>
          </div>

          <div className="mono-footer__col">
            <h5>Product</h5>
            <a href="/faqs">FAQs</a>
            <a href="/changelog">Changelog</a>
          </div>

          <div className="mono-footer__col">
            <h5>Legal</h5>
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>

          <div className="mono-footer__col">
            <h5>Community</h5>
            <div className="mono-footer__socials">
              <a className="mono-footer__social" href="https://x.com/textmono" target="_blank" rel="noopener noreferrer" aria-label="mono on X">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M13.72 10.62 20.45 3h-1.6l-5.84 6.61L8.35 3H2.97l7.06 10-7.06 8h1.6l6.17-6.99L15.67 21h5.38l-7.33-10.38Zm-2.18 2.47-.71-1.02-5.7-7.87h2.46l4.59 6.34.71 1.02 5.98 8.25h-2.46l-4.87-6.72Z" />
                </svg>
              </a>
              <a className="mono-footer__social" href="https://discord.gg/dQ6te9557e" target="_blank" rel="noopener noreferrer" aria-label="mono on Discord">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.54 5.34A17.1 17.1 0 0 0 15.3 4c-.18.33-.4.77-.54 1.12a15.9 15.9 0 0 0-4.72 0A11.5 11.5 0 0 0 9.5 4c-1.49.26-2.9.72-4.24 1.34C2.58 9.35 1.85 13.27 2.2 17.14A17.04 17.04 0 0 0 7.4 19.8c.42-.58.8-1.2 1.12-1.85-.62-.23-1.2-.52-1.76-.86.15-.11.29-.23.43-.35a12.23 12.23 0 0 0 10.42 0l.43.35c-.56.34-1.15.63-1.77.86.33.65.7 1.27 1.13 1.85a17 17 0 0 0 5.2-2.66c.42-4.48-.72-8.36-3.06-11.8ZM9.34 14.76c-1.02 0-1.86-.95-1.86-2.11 0-1.17.82-2.12 1.86-2.12 1.03 0 1.87.95 1.86 2.12 0 1.16-.83 2.11-1.86 2.11Zm5.32 0c-1.02 0-1.86-.95-1.86-2.11 0-1.17.82-2.12 1.86-2.12 1.03 0 1.87.95 1.86 2.12 0 1.16-.83 2.11-1.86 2.11Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mono-wordmark" aria-hidden="true">
        mono
      </div>
    </footer>
  );
}
